module.exports = __webpack_public_path__ + "img/klep1.4c5719bf.png";